<template lang="pug">
  include ./../../../mixins
  div.get-form
    .loading-mask(v-show="isLoading")
      .custom-loader
    validation-observer(
      ref="observer",
      tag="form",
      class="form",
      @submit.prevent="submit"
      )
        +b.g-row--space_5xl-xl.rel
          +b.g-cols--12.--6-md.g-cell
            +b.el.rel
              +b.ds-caption--size_1xs.--c_white.--w_l.--op-4.--h_200 {{transGroup.name}}*
              input-group.effect-1(
                rules='required|text|min:2|max:255'
                type="text",
                name="Name"
                :placeholder="transGroup.name"
                v-model="formData.name"
              )
          +b.g-cols--12.--6-md.g-cell.el--m_t_2xs-till-md
            +b.el.rel
              +b.ds-caption--size_1xs.--c_white.--w_l.--op-4.--h_200 {{transGroup.email}}*
              input-group(
                rules='required|email'
                type="email",
                name="Email"
                :placeholder="transGroup.email"
                v-model="formData.email"
              )
          +b.g-cols--12.g-cell.wrap-top
            +b.el.rel
              +b.ds-caption--size_1xs.--c_white.--w_l.--op-4.--h_200 {{transGroup.cmp}}
              input-group.effect-1(
                rules='text|min:2|max:255'
                type="text",
                name="Company"
                :placeholder="transGroup.cmpbig"
                v-model="formData.company"
              )
          +b.g-cols--12.g-cell.wrap-top
            +b.el.rel
              +b.ds-caption--size_1xs.--c_white.--w_l.--op-4.--h_200 {{transGroup.msg}}*
              input-group.effect-1(
                rules='required|min:5|max:1000'
                type="text",
                name="Message"
                v-model="formData.message"
              )
          +b.g-cols--12.g-cell.wrap-top
            +b.g-row--justify_between.--align_end
              +b.g-cols--12.--8-md.g-cell
                +b.el.radio-wrapper
                  validation-provider(
                    tag="div"
                    :rules="{ required: {allowFalse: false} }"
                    v-slot="{errors}"
                    name="Checkbox"
                  )
                    +b.rel
                      +b.g-row--align_center.g-cell.el--p_h_1xs-sm.--p_b_none-xl
                        input.g-cols--narrow(
                          :class="errors[0] ? 'errors': ''"
                          type="checkbox" id="check" name="Checkbox" v-model="formData.policy"
                        )
                        label.g-cols--auto.ds-caption.--w_l(
                          for="check"
                          v-html="transGroup.data"
                        )
              +b.g-cols--12.--narrow-md.g-cell
                +b.g-row--justify_end.g-cell
                  +b.el--m_t_1sm-lg.--m_t_sm-sm
                    +b.btn--arrow.arrows-contact(@click="submit")
                      +b.ds-caption--size_md-md.--size_11xs.--c_white.--w_l.--upp {{transGroup.btn}}
                      svg.arrows-svg(xmlns='http://www.w3.org/2000/svg' width='39' height='39' viewbox='0 0 39 39' fill='none')
                        path(d='M8.125 19.5L30.875 19.5' stroke='white'
                          stroke-linecap='round' stroke-linejoin='round'
                        )
                        path(d='M19.5 30.875L30.875 19.5L19.5 8.125'
                          stroke='white' stroke-linecap='round' stroke-linejoin='round'
                        )

</template>

<script>

import { submit, openModal, resetForm } from './utils'
import FormRequest from '../services/forms'

export default {
  data() {
    return {
      formData: {
        title: '',
        name: '',
        email: '',
        company: '',
        message: '',
      },
      isLoading: false,
    }
  },
  props: {
    title: {},
    transGroup: {},
  },
  mounted() {
    const arrows = document.querySelectorAll('.arrows-contact')
    if (window.innerWidth < 768 && arrows) {
      arrows.forEach(el => {
        el.querySelector('.arrows-svg').setAttribute('viewBox', '0 0 26 39');
      });
    }
    if (window.innerWidth >= 1200 && arrows) {
      arrows.forEach(el => {
        /* eslint-disable no-param-reassign */
        el.onmouseover = () => {
          el.querySelector('.arrows-svg path:nth-child(1)').setAttribute('d', 'M-1.875 19.5L30.875 19.5');
          el.querySelector('.arrows-svg path:nth-child(2)').setAttribute('d', 'M19.5 30.875L30.875 19.5L19.5 8.125');
        };
        el.onmouseout = () => {
          el.querySelector('.arrows-svg path:nth-child(1)').setAttribute('d', 'M8.125 19.5L30.875 19.5');
          el.querySelector('.arrows-svg path:nth-child(2)').setAttribute('d', 'M19.5 30.875L30.875 19.5L19.5 8.125');
        };
      });
    }
  },
  methods: {
    async submit() {
      const isValid = await submit(this.$refs.observer)
      if (isValid) {
        this.formData.title = this.title
        this.isLoading = true
        FormRequest.consultationRequest(this.formData)
        const dataTest = { title: 'Thank you!', text: 'Your message has been received, we will reply you within 24 hours' }
        openModal(this, dataTest)
          .then(({ data }) => {
            this.isLoading = false
            openModal(this, data)
            this.formData = resetForm(this.formData)
            requestAnimationFrame(() => {
              this.$refs.observer.reset()
            })
            this.closeModals()
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            this.isLoading = false
          })
        // eslint-disable-next-line no-empty
      }
    },
    closeModals() {
      this.$emit('updateParent', {
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/Forms/GetFormConsultation.vue